import React from 'react';
import { useFormContext } from 'react-hook-form';

import { AdditionalInfoFormFields } from '@/booking/validators/additional-info-form.validator';
import { Box, Flex } from '@/box';
import { useTranslation } from '@/i18n';
import { Checkbox, Label } from '@/ui/form';
import { Spacer } from '@/ui/spacing';
import { Heading } from '@/ui/typography';

export const AdditionalChildBedOrCotInputs = () => {
  const { t } = useTranslation('additionalInformation');
  const { register, watch } =
    useFormContext<Pick<AdditionalInfoFormFields, 'childBed' | 'childCot'>>();

  const [childBed, childCot] = watch(['childBed', 'childCot']);
  return (
    <div>
      <Heading as="h6" style="heading6">
        {t('additionalChildBed.title')}
      </Heading>
      <Spacer s="xxs" />
      <Flex>
        <Box width={[1 / 2, 150]}>
          {/* Hmm. We shouldn't have to know to add 'field--' here. Need to look at ID formatting. */}
          <Label htmlFor="field-childBed">
            {t('additionalChildBed.form.labels.under13Years')}
          </Label>
          <Checkbox
            isChecked={childBed.length > 0}
            label={t('additionalChildBed.form.labels.bed')}
            {...register('childBed')}
          />
        </Box>
        <Box width={[1 / 2, 150]}>
          <Label htmlFor="field-childCot">
            {t('additionalChildBed.form.labels.under3Years')}
          </Label>
          <Checkbox
            isChecked={childCot.length > 0}
            label={t('additionalChildBed.form.labels.cot')}
            {...register('childCot')}
          />
        </Box>
      </Flex>
    </div>
  );
};

export default AdditionalChildBedOrCotInputs;
